import { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import bottomBanner from "../assets/images/bottom-banner-web.png";
import logo from "../assets/images/fm-logo.png";
import youtubeIcon from "../assets/icons/youtube-yellow.png";
import instaIcon from "../assets/icons/insta-yellow.png";
import fbicon from "../assets/icons/fb-yellow.png";
import xIcon from "../assets/icons/x-yellow.png";
import arrowIcon from "../assets/icons/arrow.svg";
import { locations } from "../data/locations";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

function MapUpdater({ center, zoom, bounds, minZoom, maxZoom }) {
  const map = useMap();
  useEffect(() => {
    map.flyTo(center, zoom);
  }, [center, zoom, map]);
  
  useEffect(() => {
    if (bounds) {
      map.setMaxBounds(bounds);
    }
    if (minZoom !== undefined) {
      map.setMinZoom(minZoom);
    }
    if (maxZoom !== undefined) {
      map.setMaxZoom(maxZoom);
    }

    const handleZoomEnd = () => {
      if (map.getZoom() < minZoom) {
        map.setZoom(minZoom);
      }
    };
    map.on('zoomend', handleZoomEnd);
    return () => {
      map.off('zoomend', handleZoomEnd);
    };
  }, [map, bounds, minZoom, maxZoom]);
  return null;
}

export default function ContactUs() {
  const [openIndex, setOpenIndex] = useState(-1);

  const defaultCenter = [10.5, 76.2];
  const defaultZoom = 7;

  const currentCenter =
    openIndex !== -1 && locations[openIndex]
      ? [locations[openIndex].lat, locations[openIndex].lng]
      : defaultCenter;
  const currentZoom = openIndex !== -1 ? 13 : defaultZoom;

  return (
    <section
      id="contact"
      className="container relative w-full mx-auto  bg-cover bg-center md:mt-12"
      style={{ backgroundImage: `url(${bottomBanner})` }}
    >
      <div className="flex justify-start">
        <h2 className="text-lg md:text-2xl font-normal text-black py-2 px-4 md:py-4 md:px-6 bg-white">
          CONTACT US
        </h2>
      </div>

      <div className="container mx-auto relative z-10 p-4 md:p-6 flex flex-col lg:flex-row gap-6 lg:gap-12">
        <div className="w-full lg:w-1/3 flex flex-col gap-1">
          <div className="flex justify-center items-center mb-4">
            <img src={logo} alt="logo" className="w-20" />
          </div>
          {locations.map((loc, index) => (
            <div key={index} className="w-full">
              <button
                onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
                className={`w-full flex justify-between items-center px-6 py-3 text-lg md:text-2xl uppercase transition-colors bg-club-yellow text-black`}
              >
                <span/>
                <span>{loc.name}</span>
                <img
                  src={arrowIcon}
                  alt="arrow"
                  className={`w-4 h-4 transform transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""
                    }`}
                />
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out bg-[#262626] text-white
                            ${openIndex === index
                    ? "max-h-64 opacity-100"
                    : "max-h-0 opacity-0"
                  }`}
              >
                <div className="p-4 text-center text-sm font-medium">
                  <p className="mb-1">{loc.address}</p>
                  <p className="text-club-yellow">
                    OFF : <span className="text-club-yellow">{loc.off}</span> ,
                    WHATSAPP :{" "}
                    <span className="text-club-yellow">{loc.whatsapp}</span>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="w-full lg:w-2/3">
          <div className="w-full h-full min-h-[300px] lg:min-h-[400px] shadow-xl">
            <MapContainer
              center={defaultCenter}
              zoom={defaultZoom}
              scrollWheelZoom={false}
              attributionControl={false}
              className="w-full h-full min-h-[400px]"
              style={{ height: "100%", width: "100%" }}
              maxBounds={[[6.0, 73.0], [16.0, 85.0]]}
              maxBoundsViscosity={1}
              minZoom={7}
              maxZoom={15}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <MapUpdater center={currentCenter} zoom={currentZoom} bounds={[[6.0, 73.0], [16.0, 85.0]]} minZoom={7} maxZoom={15} />

              {locations.map((loc, index) => (
                <Marker
                  key={index}
                  position={[loc.lat, loc.lng]}
                  eventHandlers={{
                    click: () => {
                      setOpenIndex(index);
                    },
                  }}
                >
                  <Popup>
                    <strong className="text-club-yellow">
                      {loc.name}
                    </strong>
                    <br />
                    {loc.address}
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>
        </div>
      </div>
      <div className="flex justify-end items-center gap-2 pb-4 md:pb-6 px-4 md:px-6">
        <a
          href="https://www.youtube.com/clubfmkerala"
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center cursor-pointer focus:outline-none bg-dark-gray p-1"
        >
          <img src={youtubeIcon} alt="youtube" className="w-8 h-8 mt-0.5" />
        </a>
        <a
          href="https://www.instagram.com/clubfmkerala"
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center cursor-pointer focus:outline-none bg-dark-gray p-1"
        >
          <img src={instaIcon} alt="insta" className="w-8 h-8 mt-0.5" />
        </a>
        <a
          href="https://www.facebook.com/clubfmkerala/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center cursor-pointer focus:outline-none bg-dark-gray p-1"
        >
          <img src={fbicon} alt="fb" className="w-8 h-8 mt-0.5" />
        </a>
        <a
          href="https://x.com/clubfmkerala"
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center cursor-pointer focus:outline-none bg-dark-gray p-1"
        >
          <img src={xIcon} alt="x" className="w-8 h-8 mt-0.5" />
        </a>
      </div>
    </section>
  );
}
